import { call, put, takeLatest } from "redux-saga/effects";
import types from "./types";
import apiClientFactory from "../../backend/apiClient";
import endPoint from "../../backend/endpoints";

//get
function* getSubQualityManagmentHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.get,
			endPoint.dynamicList({ path: "subqualitymanagment", ...action.payload }),
		);
		yield put({
			type: types.GET_SUB_QUALITY_MANAGMENT_SUCCESS,
			payload: data.response,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.GET_SUB_QUALITY_MANAGMENT_ERROR,
			payload,
		});
	}
}

export function* getSubQualityManagmentWatcherSaga() {
	yield takeLatest(types.GET_SUB_QUALITY_MANAGMENT_START, getSubQualityManagmentHandlerSaga);
}

//create

//delete

function* deleteSubQualityManagmentHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.delete,
			endPoint.deleteDyanamicItem("subqualitymanagment", action.payload),
		);
		yield put({
			type: types.DELETE_SUB_QUALITY_MANAGMENT_SUCCESS,
			payload: data,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.DELETE_SUB_QUALITY_MANAGMENT_ERROR,
			payload,
		});
	}
}

export function* deleteSubQualityManagmentWatcherSaga() {
	yield takeLatest(types.DELETE_SUB_QUALITY_MANAGMENT_START, deleteSubQualityManagmentHandlerSaga);
}

//update
